/**
 *
 * Tooltip
 *
 */

import React from 'react';
import { Tooltip as CustomTooltip } from 'antd';

import './style.less';

function Tooltip({ ...rest }: any) {
  return <CustomTooltip {...rest} />;
}

export default Tooltip;
